module.exports = __webpack_public_path__ + "img/20230307101659312aob.fabd4f58.jpg";